import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "sonner";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import CookieBanner from "./components/layout/CookieBanner";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ReferralsPage from "./pages/ReferralsPage";
import SafeguardingPage from "./pages/SafeguardingPage";
import ImpactPage from "./pages/ImpactPage";
import WorkWithUsPage from "./pages/WorkWithUsPage";
import ContactPage from "./pages/ContactPage";

import "./App.css";

function App() {
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (accepted === "true") {
      setCookiesAccepted(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setCookiesAccepted(true);
  };

  return (
    <div className="min-h-screen grain-overlay">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/referrals" element={<ReferralsPage />} />
            <Route path="/safeguarding" element={<SafeguardingPage />} />
            <Route path="/impact" element={<ImpactPage />} />
            <Route path="/work-with-us" element={<WorkWithUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        {!cookiesAccepted && <CookieBanner onAccept={handleAcceptCookies} />}
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
